import { Box, Typography } from "@mui/material"

import ErrorIcon from '@mui/icons-material/Error';

const GeneralError = (props) => {
	return (
		<Box sx={{display: 'flex', width: '100%', height: props.height ? props.height : '100%', alignItems: 'center', justifyContent: 'center'}}>
			<ErrorIcon fontSize="large" color="error"/> 
			<Typography variant="h6" paddingLeft={1}>{props.message}</Typography>
		</Box>
	)
}

export default GeneralError